import React from 'react';
import {
  CheckinDateLabel,
  DayBoxItem,
  DayBoxWrapper,
  Wrapper,
} from './gant-row-cell-styles';

const MMDD_START_INDEX = 5;

// faster than getting date object
function mmddNoYear(yymmdd) {
  return yymmdd?.substring(MMDD_START_INDEX);
}

function DayBox({ booked, isCheckin, isWeekend, bookDate, color }) {
  return (
    <DayBoxWrapper isweekend={isWeekend}>
      {isCheckin && <CheckinDateLabel>{mmddNoYear(bookDate)}</CheckinDateLabel>}
      <DayBoxItem booked={booked} color={color} />
    </DayBoxWrapper>
  );
}

/**
 * Displays Gantt chart values for a listing.
 * Each cell draws values for an entire month.
 * This object enables toggling between colors for coloring booked days.
 * Also defines color for unbooked days
 */

export function GantRowCell(props) {
  const {
    value: calendarActivity, // the actual activity for each day of the month
    weekendsInMonth, // array that tells which day indexes correspond to weekends
    context: { colorGetter },
  } = props;

  // calendarActivity may be undefined when the current cell corresponds to a group row
  if (!calendarActivity) {
    // no need to draw booked/blocked activity, but weekends still marked
    return (
      <Wrapper>
        {weekendsInMonth.map((isWeekend, i) => (
          <DayBoxWrapper key={`group-date-${i}`} isweekend={isWeekend} />
        ))}
      </Wrapper>
    );
  }

  // TODO: update data. We don't need [{ booked, bookDate }, ...]. Just bookDate[]

  return (
    <Wrapper>
      {calendarActivity.map((dayData, i) => {
        const previousDayBookDate = calendarActivity[i - 1]?.bookDate;
        // what if two people booked different reservations back to back on the same day?
        const isCheckin =
          dayData.bookDate && previousDayBookDate !== dayData.bookDate;
        const color = colorGetter(dayData, isCheckin);

        return (
          <DayBox
            key={`day-${i}`}
            booked={dayData?.booked}
            bookDate={dayData?.bookDate}
            isCheckin={isCheckin}
            isWeekend={weekendsInMonth[i]}
            color={color}
          />
        );
      })}
    </Wrapper>
  );
}
